/**
 * Common enum dropdown component connected to create form provider
 */
import { useRfiForm } from '../../../RfiCreateForm/RfiFormProvider';
import { EnumDropdown, EnumDropdownProps } from './EnumDropdown';

export const EnumDropdownCreateForm = (props: EnumDropdownProps) => {
  const { fieldName } = props;
  const { mandatoryFields, isSubmitting, refs } = useRfiForm();
  const isFieldsMandatory = mandatoryFields.includes(fieldName);

  return (
    <EnumDropdown
      {...props}
      ref={refs[fieldName]}
      disabled={isSubmitting}
      required={isFieldsMandatory}
    />
  );
};
